import { store } from "@store/store";
import { setToastData } from "@store/slices/globalState";
import Router from "next/router";

const dashcamInstallationConfirmationApi = async (data: any) => {
  const { order_id } = Router.query;
  const url = `${process.env.SDUI_API_SERVICE}/dashcam-installation-confirmation`;

  const bodyData = {
    ...data,
    order_id: order_id
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyData)
    });

    if (!response.ok) {
      throw new Error(`Error in dashcamInstallationConfirmation API`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("dashcamInstallationConfirmation Error:", error);
    throw error;
  }
};

export const dashcamInstallationConfirmation = async (data: any) => {
  try {
    const response = await dashcamInstallationConfirmationApi(data);
    return response;
  } catch (error: any) {
    store?.dispatch(
      setToastData({
        toastMessage: "Something went wrong",
        toastMessageType: "error"
      })
    );
    throw error;
  }
};
